import { CardComponentProps } from "@~/types/types";
import styles from "./Price.module.scss";
import {
  transformVariantPriceRange,
  transformBlindPrice,
  isPriceAtLeastMinimumThreshold,
  getCreditMessage,
} from "./utils";
import JLDSPrice from "@JohnLewisPartnership/jl-design-system/dist/components/price/Price";
import { PDPLink } from "../__shared__/PDPLink/PDPLink";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export function Price({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { variantPriceRange } = product;

  const transformedVariantPrice = variantPriceRange
    ? transformVariantPriceRange(variantPriceRange)
    : null;

  if (!transformedVariantPrice) return null;

  if (!isPriceAtLeastMinimumThreshold(transformedVariantPrice)) return null;

  const isM2MRollerBlind =
    product.configurationRequirements?.type?.includes(
      "MadeToMeasureRollerBlind",
    ) || false;

  const price = isM2MRollerBlind
    ? transformBlindPrice(transformedVariantPrice)
    : transformedVariantPrice;

  const pricePrefix = isM2MRollerBlind ? "Blind price from" : undefined;

  const hasDiorPromosEnabled = !!configProps?.hasDiorPromosEnabled || false;

  const creditMessage = getCreditMessage(transformedVariantPrice, product);

  const brand = product.brand?.name.toLocaleLowerCase();
  const brandName = brand === "anyday" || brand === "dior" ? brand : "";

  const priceElement = (
    <JLDSPrice
      {...(brandName && { brand: brandName })}
      className={cx("price", {
        "price--responsive": configProps?.isResponsive,
      })}
      dataTestIdPrefix="product-card"
      hasDiorPromosEnabled={hasDiorPromosEnabled}
      price={price}
      creditMessage={creditMessage}
      isProductCardDetailed
      {...(pricePrefix && { pricePrefix })}
    />
  );

  return (
    <PDPLink
      product={product}
      componentName="Price"
      tabIndex={-1}
      className={cx("price__container")}
      noFollow={configProps?.noFollow === true}
    >
      {priceElement}
    </PDPLink>
  );
}
